<div class="kiosk-setup-container">
  <div class="kiosk-setup-card">
    <div class="setup-header">
      <div class="brand-badge">
        <span class="brand-dot"></span>
        <span>DCS LIVE ENERGY DISPLAY</span>
      </div>
      <h1 class="setup-title">Kiosk Device Pairing</h1>
      <p class="setup-subtitle">
        Connect this dedicated display unit to your Carbon monitoring site without requiring user credentials.
      </p>
    </div>

    <div class="setup-body">
      <div *ngIf="errorMessage" class="error-banner" role="alert">
        <span class="error-icon">⚠️</span>
        <span class="error-text">{{ errorMessage }}</span>
      </div>

      <div *ngIf="storedKeyExists" class="stored-key-section">
        <div class="stored-key-info">
          <span class="stored-label">Paired Device Key:</span>
          <span class="stored-masked">••••••••••••••••</span>
        </div>
        <div class="setup-actions">
          <button
            type="button"
            class="btn btn-primary btn-tv"
            [disabled]="isLoading"
            (click)="onProceedWithStoredKey()"
          >
            <span *ngIf="!isLoading">▶ Connect Display</span>
            <span *ngIf="isLoading" class="spinner">Verifying...</span>
          </button>
          <button
            type="button"
            class="btn btn-secondary btn-tv"
            [disabled]="isLoading"
            (click)="onClearStoredKey()"
          >
            Clear Paired Key
          </button>
        </div>
        <div class="divider">
          <span>OR ENTER NEW KEY</span>
        </div>
      </div>

      <form (ngSubmit)="onConnect()" autocomplete="off">
        <div class="form-group">
          <label for="deviceKeyInput" class="input-label">Device Key</label>
          <div class="input-wrapper">
            <input
              id="deviceKeyInput"
              [type]="hideKey ? 'password' : 'text'"
              class="form-control key-input"
              placeholder="Paste or enter kiosk device key"
              [(ngModel)]="deviceKey"
              name="deviceKey"
              autofocus
              autocomplete="off"
              spellcheck="false"
            />
            <button
              type="button"
              class="btn-toggle-vis"
              (click)="hideKey = !hideKey"
              tabindex="-1"
              [attr.aria-label]="hideKey ? 'Show key' : 'Hide key'"
            >
              {{ hideKey ? '👁️' : '🔒' }}
            </button>
          </div>
          <span class="input-hint">
            Device keys are configured securely per display in Carbon configuration.
          </span>
        </div>

        <div class="setup-actions" *ngIf="!storedKeyExists">
          <button
            type="submit"
            class="btn btn-primary btn-tv"
            [disabled]="isLoading || !deviceKey"
          >
            <span *ngIf="!isLoading">Pair and Launch Display</span>
            <span *ngIf="isLoading" class="spinner">Verifying Key...</span>
          </button>
        </div>
        <div class="setup-actions" *ngIf="storedKeyExists && deviceKey">
          <button
            type="submit"
            class="btn btn-primary btn-tv"
            [disabled]="isLoading"
          >
            <span *ngIf="!isLoading">Save New Key and Connect</span>
            <span *ngIf="isLoading" class="spinner">Verifying Key...</span>
          </button>
        </div>
      </form>
    </div>

    <div class="setup-footer">
      <span>Site Identity Isolation &bull; 15-min Rolling Token &bull; Hardware Display Mode</span>
    </div>
  </div>
</div>
